import React from 'react';
import Header from '../components/layout/Header';
import QuickTools from '../components/dashboard/QuickTools';
import ContinuingStudents from '../components/dashboard/ContinuingStudents';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-6">
        <QuickTools />
        <ContinuingStudents />
      </main>
    </div>
  );
};

export default HomePage;
